define.alias("shared/components/shared/wizard/next-button", "media/components/shared/wizard/next-button");